import React from 'react';

import PanelWrapper from '@/components/PanelWrapper/PanelWrapper';
import { Skeleton } from '@/components/shadcn/ui/skeleton';
import { Table } from '@/components/shadcn/ui/table';

import SwapTableBodySkeleton from './SwapTable/SwapTableBodySkeleton';
import SwapTableHeaderSkeleton from './SwapTable/SwapTableHeaderSkeleton';

const HistorySkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <PanelWrapper>
        <div className="flex w-full max-w-[1000px] flex-col gap-4 sm:grid-cols-2 md:w-[700px] lg:w-[1000px]">
          <div className="flex flex-row justify-between">
            <Skeleton className="h-7 w-[150px]" variant="background" />
          </div>

          <div className="w-full">
            <Table className="min-w-[calc(840px+32px)]">
              <SwapTableHeaderSkeleton />
              <SwapTableBodySkeleton count={10} />
            </Table>
          </div>
        </div>
      </PanelWrapper>
    </div>
  );
};

export default HistorySkeleton;
